import { createCreator } from "../createMockData/createCreator";

// avatars
import SuzanneAvatar from "./suzanne.jpg";

export const creators = [
    createCreator({
        id: "creator-1",
        avatar: SuzanneAvatar,
        name: `Sarah H. Johnson`,
        username: "sarah.h.johnson"
    }),
    createCreator({
        id: "creator-2",
        avatar:
            "https://1.bp.blogspot.com/-5WghCuP_naE/T6TcHXpuxDI/AAAAAAAAKHs/_KKqAXtViww/s1600/EG.jpg",
        name: `Helen Parr`,
        username: "elastagirl"
    }),
    createCreator({
        id: "creator-3",
        avatar:
            "https://i.pinimg.com/564x/71/22/57/7122574844990c3c4e2600ae98771153.jpg",
        name: `Bob Parr`,
        username: "mr.incredible"
    })
];
